// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__yWCL6","text":"styles_text__cZGPZ"};